import { useEffect, useMemo, useState } from "react";
import ChecklistService, { ChecklistTemplate } from "@/app/_services/ChecklistService";
import { toast } from "@/app/_utils/toast";

export function useChecklistsModel() {
  const [templates, setTemplates] = useState<ChecklistTemplate[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");

  async function loadTemplates() {
    setIsLoading(true);
    try {
      setTemplates(await ChecklistService.getTemplatesAsync());
    } catch (error) {
      console.error(error);
      toast.error("Could not load checklist templates");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    loadTemplates();
  }, []);

  async function handleDelete(template: ChecklistTemplate) {
    try {
      await ChecklistService.deleteTemplateAsync(template.id);
      toast.success(`${template.name} deleted`);
      setTemplates((current) => current.filter((t) => t.id !== template.id));
    } catch (error) {
      console.error(error);
      toast.error("Could not delete this template");
    }
  }

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return templates;
    return templates.filter(
      (t) =>
        t.name.toLowerCase().includes(term) || t.description.toLowerCase().includes(term)
    );
  }, [templates, search]);

  return {
    templates: filtered,
    totalCount: templates.length,
    isLoading,
    search,
    setSearch,
    handleDelete,
  };
}
